import { useState } from 'react';

import { Text } from '@/components/shared/components/Text';

import { BusinessActions } from '../types/BusinessActions';

export const useBusinessDetailsActions = ({ editModeAllowed, businessOnboarding, toggleDialog }) => {
  const [dialogAction, setDialogAction] = useState<undefined | BusinessActions>(undefined);
  const toggleEditDialog = () => {
    setDialogAction(BusinessActions.EDIT_DIALOG);
    toggleDialog();
  };

  const toggleEditModeDialog = editModeAllowed && businessOnboarding ? toggleEditDialog : undefined;

  const businessBaseActionsOptions = toggleEditModeDialog && [
    {
      display: <Text tId={'EDIT_INFORMATION'} />,
      onClick: toggleEditModeDialog,
      iconName: 'edit',
    },
  ];

  return { dialogAction, toggleEditModeDialog, businessBaseActionsOptions };
};
